<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-cascader
        class="select_btn_style"
        v-model="filters.categoryId"
        placeholder="音频集分类"
        :options="videoCategoryData"
        :props="{
          label: 'name',
          value: 'id',
          children: 'children',
          checkStrictly: true,
        }"
        clearable
      >
      </el-cascader>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.onlineStatus"
        placeholder="上线状态"
      >
        <el-option
          v-for="(item, i) in onlineStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.sharedStatus"
        placeholder="共享状态"
      >
        <el-option
          v-for="(item, i) in sharedStatus"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.audioSetName"
        placeholder="请输入音频集名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
import { resCategoryTree } from "@/api/rescategory";
export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      filters: {},
      onlineStatusData: [],
      sharedStatus: [],
      videoCategoryData: [],
      showName: "",
      defaultProps: {
        children: "children",
        label: "name",
      },
    };
  },
  created() {
    resCategoryTree({ categoryType: 2, display: 1 }).then((res) => {
      if (!res || res.code != 0) return;
      // res.data.splice(0, 0, {
      //   id: "",
      //   name: "全部",
      // });
      this.videoCategoryData = res.data;
    });
    this.getSysParamByTypes(["ONLINE_STATUS", "SHARED_SCREEN_STATUS"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["ONLINE_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["SHARED_SCREEN_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.onlineStatusData = res.data["ONLINE_STATUS"];
        this.sharedStatus = res.data["SHARED_SCREEN_STATUS"];
      });
    },
    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([data]);
        this.filters.categoryId = data.id;
        this.showName = data.name;
      }
    },
    initData() {
      //查询
      this.$emit("search", {
        ...this.filters,
        t: new Date().getTime(),
        categoryId: this.filters.categoryId
          ? JSON.parse(JSON.stringify(this.filters.categoryId)).pop()
          : "",
      });
    },
    resetData() {
      //重置
      this.showName = "";
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>


<style lang="scss" scoped>
.tree-content {
  max-height: 400px;
  overflow: auto;
}
.sel-button {
  cursor: pointer;
  width: 118px;
  height: 30px;
  text-align: center;
  background: #edf2f9;
  border-radius: 2px;
  border: 1px solid #d7dbe0;
}
</style>